import { ReportEdit as ReportEditComponent } from '@/components/home/report-editor';
import { getReportRouteSegment } from '@/lib/reports/status';
import { useReviewPromptStore } from '@/stores/review-prompt';
import { convexQuery } from '@convex-dev/react-query';
import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import { Navigate, useOutletContext } from 'react-router-dom';
import { api } from '~/convex/_generated/api';
import type { ReportContextType } from './layout';

export const ReportEdit = () => {
  const { report } = useOutletContext<ReportContextType>();
  const routeSegment = getReportRouteSegment(report.status);
  const setShowReviewSheet = useReviewPromptStore((s) => s.setShowReviewSheet);

  const { data: shouldShowReview, isFetching: isCheckingReview } = useQuery({
    ...convexQuery(api.appReviews.shouldShowReviewPrompt, {}),
    enabled: routeSegment === 'edit',
  });

  useEffect(() => {
    if (routeSegment !== 'edit' || isCheckingReview) return;
    if (shouldShowReview !== true) return;
    setShowReviewSheet(true);
  }, [routeSegment, isCheckingReview, shouldShowReview, setShowReviewSheet]);

  if (routeSegment !== 'edit') {
    return <Navigate to={`/reports/${report._id}/${routeSegment}`} replace />;
  }

  return <ReportEditComponent report={report} />;
};
